<template>
  <v-row justify="center" align="center">
    <v-btn small icon @click="onItemEdit" :disabled="editDisabled">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon small color="teal" v-on="on">mdi-pencil</v-icon>
        </template>
        <span>Modify Item</span>
      </v-tooltip>
    </v-btn>

    <v-btn
      icon
      small
      @click="onEditItemPrices"
      :disabled="pricingDisabled"
      v-if="itemData.serviceType && itemData.serviceType != 'MANDATORY_CHARGES'"
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon :color="customPricingFlagColor" small v-on="on">{{
            itemData && itemData.customPricing
              ? "mdi-currency-usd"
              : "mdi-currency-usd-off"
          }}</v-icon>
        </template>
        <span>Pricing</span>
      </v-tooltip>
    </v-btn>
    <v-avatar
      v-if="itemData && itemData.allocation && ź.allocation != ''"
      color="indigo lighten-2"
      size="26"
      dark
      ><span class="white--text"><strong>FA</strong></span></v-avatar
    >
    <v-tooltip bottom v-if="itemData && itemData.hasPurchaseInvoice">
      <template v-slot:activator="{ on }">
        <v-icon v-on="on">mdi-information-variant</v-icon>
      </template>
      <span
        >This service cannot be deleted because there is a purchase invoice
        associated with it. If you remove the purchase invoice in the Accounts
        section then you can delete this service.</span
      >
    </v-tooltip>
    <confirmation-dialog @onConfirm="onItemRemove" :item="itemData" v-else>
      <v-btn small icon :disabled="itemData.isExternal">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon small color="pink" v-on="on">mdi-delete</v-icon>
          </template>
          <span>Remove Item</span>
        </v-tooltip>
      </v-btn>
      <p slot="message">This will remove service.</p>
    </confirmation-dialog>
  </v-row>
</template>

<script>
import ConfirmationDialog from "../../shared/ConfirmationDialog";
export default {
  name: "itinerary-items-list-actions",

  props: {
    item: {
      type: Object,
      default: () => null,
    },
  },

  components: { ConfirmationDialog },

  computed: {
    editDisabled() {
      return this.itemData.isExtra;
    },
    pricingDisabled() {
      return this.itemData.isExtra;
    },
    itemData() {
      return this.params ? { ...this.params.data } : { ...this.item };
    },
    customPricingFlagColor() {
      return this.itemData && this.itemData.customPricing
        ? "green darken-2"
        : "grey";
    },
  },

  methods: {
    onItemEdit(item) {
      if (this.params) {
        this.params.context.componentParent.onItemEdit(this.itemData);
      } else {
        this.$emit("editItem", this.itemData);
      }
    },
    onItemRemove(item) {
      if (this.params) {
        this.params.context.componentParent.onItemRemove(this.itemData);
      } else {
        this.$emit("removeItem", this.itemData);
      }
    },
    onEditItemPrices(item) {
      if (this.params) {
        this.params.context.componentParent.onEditItemPrices(this.itemData);
      } else {
        this.$emit("editItemPrices", this.itemData);
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/ItineraryItemsListActions.vue